import React, { useEffect, useState } from 'react'
import ClearIcon from '@mui/icons-material/Clear';
import { Box, Button, IconButton } from '@mui/material';
import styles from './modal.module.css'
import iconDelete from '../../assets/icons/delete_white.svg'
import * as api from '../../pages/services/api'
import Loader from '../Loader';

function ModalDisableUser({ onClose, uid }) {
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        console.log(uid)
    }, [])

    const disableUser = async () => {
        setLoading(true)
        let res = await api.disableUser(uid)
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                alert('บันทึกสำเร็จ')
                onClose()
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            <Loader loading={loading} />
            <Box className={styles.backgroundModal}>
                <Box className={styles.boxModal1}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', gridGap: '10px' }}>
                            <Box sx={{ border: '5px solid #478F96' }} />
                            <Box sx={{
                                fontWeight: 600,
                                fontSize: '18px',
                                color: '#478F96',
                                "@media (max-width: 800px)": {
                                    fontSize: '16px',
                                }
                            }}>ยกเลิกบัญชี</Box>
                        </Box>
                        <Box sx={{ '&:hover': { cursor: 'pointer' } }}>
                            <IconButton onClick={() => { onClose() }}>
                                <ClearIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'grid', textAlign: 'center', gridGap: '20px' }}>
                        <Box sx={{
                            fontSize: '16px',
                            "@media (max-width: 800px)": {
                                fontSize: '14px'
                            }
                        }}

                        >
                            <Box>ท่านต้องการลบบัญชีนี้ใช่หรือไม่</Box>
                            <Box>หากลบแล้วจะไม่สามารถเข้าใช้งานระบบได้อีกในครั้งถัดไป</Box>
                        </Box>
                        <Box>
                            <Button
                                sx={{ backgroundColor: '#E06262', color: '#FFFFFF', fontWeight: 600 }}
                                onClick={() => {
                                    disableUser()
                                }}
                            >
                                <img src={iconDelete} style={{ width: '15px', marginRight: '5px' }} />
                                <span>ยืนยันการลบ</span>
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default ModalDisableUser
